@for (message of messages; track message) {
  <div style="text-align: center">
    {{ message }}
  </div>
}
